<!-- static content data from lang: site_management -->
<template>
  <div>
    <base-header class="pb-6" v-loading="loading">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ lang.label.AddheaderTitle }}
          </h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <Alert :type="alertMessage ? alertMessage.type : ''" dismissible v-if="alertMessage && alertMessage.type">
              <span class="alert-inner--text">{{ alertMessage.message }} </span>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </Alert>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input :label="lang.label.companyName" name="company name" rules="required|max:50"
                          labelClasses="form-control-label asterisk-mark">
                          <el-select v-model="model.companyName" autocomplete="off"
                            :placeholder="lang.label.selectCompany" filterable :disabled="isCompanyAdmin">
                            <el-option v-for="(option, index) in companyName" :key="index" :label="option.Name"
                              :value="option.Name"></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input :label="lang.label.siteName" name="site name" rules="required"
                          v-model="model.siteName" autocomplete="off"
                          labelClasses="form-control-label asterisk-mark"></base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input :label="lang.label.modeOfCommunication"
                          labelClasses="form-control-label asterisk-mark" name="communication mode"
                          :rules="{ required: true }">
                          <b-form-group class="mb-0">
                            <b-form-radio-group id="radio-group" v-model="model.mode" autocomplete="off"
                              :options="communicationModes" name="radio-options"></b-form-radio-group>
                          </b-form-group>
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <label>&nbsp;</label>
                        <base-input name="auto approve">
                          <div>
                            <b-form-group>
                              <b-form-checkbox-group id="approve" v-model="checked" :options="approve" name="roles"
                                aria-label="auto approve"></b-form-checkbox-group>
                            </b-form-group>
                          </div>
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input label="Start Date/Time must be before X hours" name="Start Date/Time"
                          rules="numeric" v-model="model.hours" autocomplete="off"
                          @input="checkHours($event)"></base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input :label="lang.label.covidSafety" labelClasses="form-control-label asterisk-mark"
                          name="covid safety option" :rules="{ required: true }">
                          <b-form-group class="mb-0">
                            <b-form-radio-group id="covidSafety-radio-group" v-model="model.covidSafety"
                              autocomplete="off" :options="covidSafetyOptions"
                              name="covidSafety-radio-options"></b-form-radio-group>
                          </b-form-group>
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input :label="lang.label.frequencyWeek" name="frequency week" :rules="{
                          required: true,
                          regex:
                            /^(0|[1-9]?[0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,
                        }" autocomplete="off" v-model="model.frequencyWeek"
                          labelClasses="form-control-label asterisk-mark"></base-input>
                      </div>
                      <div class="col-md-12">
                        <div class="work-types-section card mt-4 mb-4">
                          <div class="card-header border border-solid border-primary">
                            <h3 class="text-primary mb-0">Department Management</h3>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <!-- Add Work Type Form -->
                              <div class="col-md-6 border-right">
                                <h4 class="mb-4">Add New Department</h4>
                                <div class="work-type-form p-3 border rounded">
                                  <div class="row">
                                    <!-- Work Type Input -->
                                    <div class="col-md-12 mb-3">
                                      <base-input :label="'Add ' + lang.label.departmentTypes" name="workTypes"
                                        autocomplete="off" v-model="departmentName"
                                        labelClasses="form-control-label asterisk-mark"></base-input>
                                    </div>
                                    <!-- Add Button -->
                                    <div class="col-12">
                                      <button type="button" @click="addDepartment" class="btn btn-primary btn-block">
                                        <i class="fas fa-plus-circle mr-2"></i>Add Department
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Work Types Table -->
                              <div class="col-md-6">
                                <h3>Departments</h3>
                                <div v-for="(department, depIndex) in departments" :key="depIndex" class="mb-3">
                                  <!-- Department Header -->
                                  <div class="card">
                                    <div class="card-header d-flex justify-content-between align-items-center">
                                      <h5 class="mb-0">
                                        <span v-if="!department.editing">{{ department.name }}</span>
                                        <input v-else type="text" v-model="department.name" class="form-control"
                                          placeholder="Enter department name" />
                                      </h5>
                                      <div>
                                        <button type="button" v-if="!department.editing" class="btn btn-sm btn-primary"
                                          @click="editDepartment(depIndex)">
                                          Edit
                                        </button>
                                        <button type="button" v-if="department.editing"
                                          class="btn btn-outline-success btn-sm" @click="saveDepartment(depIndex)">
                                          Save
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm"
                                          @click="removeDepartment(depIndex)">
                                          Delete
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary"
                                          @click="toggleDepartment(depIndex)">
                                          {{ department.expanded ? "Collapse" : "Expand" }}
                                        </button>
                                      </div>
                                    </div>

                                    <!-- Department Content -->
                                    <div v-if="department.expanded" class="card-body">
                                      <!-- Approver Levels -->
                                      <div v-for="(level, index) in approverLevels" :key="level.key" class="mb-3">
                                        <!-- Conditional Display of Levels -->
                                        <template
                                          v-if="index === 0 || validate(depIndex, approverLevels[index - 1].key)">
                                          <h6>{{ level.label }}</h6>

                                          <!-- Dropdown for IDs -->
                                          <el-select v-model="department[level.key].ids" class="flex-grow-1 mb-3"
                                            placeholder="Select approvers" multiple filterable
                                            @change="handleApproverSelection(depIndex, level.key)">
                                            <el-option v-for="option in getApproversNameByCompany" :key="option.ID"
                                              :label="option.Name" :value="option.ID"></el-option>
                                          </el-select>

                                          <!-- Add Email Button -->
                                          <button type="button" class="btn btn-outline-secondary btn-sm"
                                            @click="openApproverModal(depIndex, level.key, index)">
                                            Add Email
                                          </button>
                                          <div v-for="(data, emailDataIndex) in department[level.key]"
                                            :key="'email-' + emailDataIndex" class="d-flex align-items-center mb-2">
                                            Email: {{ data.EmailAddress }}
                                            <button type="button" class="btn btn-outline-danger btn-sm ml-2"
                                              @click="removeEmail(depIndex, level.key, emailDataIndex)">
                                              Delete
                                            </button>
                                          </div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="col-md-12 mt-3">
                        <!-- Work Types Section -->
                        <div class="work-types-section card mt-4 mb-4">
                          <div class="card-header border border-solid border-primary">
                            <h3 class="text-primary mb-0">Work Types Management</h3>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <!-- Add Work Type Form -->
                              <div class="col-md-6 border-right">
                                <h4 class="mb-4">Add New Work Type</h4>
                                <div class="work-type-form p-3 border rounded">
                                  <div class="row">
                                    <!-- Work Type Input -->
                                    <div class="col-md-12 mb-3">
                                      <base-input :label="lang.label.workTypes" name="workTypes" autocomplete="off"
                                        v-model="newWorkType" labelClasses="form-control-label asterisk-mark">
                                      </base-input>
                                    </div>

                                    <!-- Work Permit Template Input -->
                                    <div class="col-md-12 mb-3">
                                      <base-input :label="'Add ' + lang.label.workPermit" name="workTypes"
                                        autocomplete="off" labelClasses="form-control-label asterisk-mark">
                                        <el-input v-model="work_permit_template" type="textarea" :rows="4"
                                          :placeholder="'Enter work permit template'" resize="vertical"
                                          class="custom-textarea">
                                        </el-input>
                                      </base-input>
                                    </div>

                                    <!-- Required Documents Select -->

                                    <div class="col-md-12 mb-3">
                                      <base-input 
                                        :label="lang.label.requiredDocuments" 
                                        name="required_documents" 
                                       
                                        labelClasses="form-control-label asterisk-mark"
                                      >
                                        <el-select 
                                          v-model="documentName" 
                                          autocomplete="off"
                                          placeholder="Type and press Enter to add document" 
                                          filterable 
                                          multiple
                                          class="w-100"
                                          default-first-option
                                          value-key="id"
                                          @keyup.enter.native="handleEnterPress"
                                        >
                                          <el-option 
                                            v-for="doc in requiredDocument" 
                                            :key="doc.id || doc.name"
                                            :label="doc.name || doc"
                                            :value="{ id: doc.id, name: doc.name }"
                                          >
                                            {{ doc.name || doc }}
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </div>

                                    <!-- Add Button -->
                                    <div class="col-12">
                                      <button type="button" @click="addWorkType" class="btn btn-primary btn-block">
                                        <i class="fas fa-plus-circle mr-2"></i>Add Work Type
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Work Types Table -->
                              <div class="col-md-6">
                                <h4 class="mb-4">Existing Work Types</h4>
                                <div class="work-types-table">
                                  <b-table :items="workTypes" striped hover responsive class="border">
                                    <template #cell(id)="data">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ data.index +1 }}</strong>
                                      </div>
                                    </template>
                                    <template #cell(documentName)="data">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <el-tag size="medium" type="info" class="mr-2" v-for="(doc, index) in data.item.documentName" :key="index">
                                          {{ doc.name|| doc }}
                                        </el-tag>
                                      </div>
                                    </template>
                                    <template #cell(name)="data">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ data.item.name }}</strong>
                                      </div>
                                    </template>
                                    <template #cell(actions)="data">
                                      <div class="">
                                        <b-button size="sm" variant="info" @click="showEditModal(data.item, data.index)"
                                          class="mr-2">
                                          <i class="fas fa-edit"></i>
                                        </b-button>
                                        <b-button size="sm" variant="danger" @click="showDeleteModal(data.index)">
                                          <i class="fas fa-trash-alt "></i>
                                        </b-button>
                                      </div>
                                    </template>
                                  </b-table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <b-modal id="editWorkTypeModal" title="Edit Work Type" @cancel="closeEditModal"
                          @ok="confirmEditWorkType">
                          <div>
                            <b-form-group :label="'Edit ' + lang.label.workTypes" label-for="editWorkTypeInput">
                              <b-form-input id="editWorkTypeInput" v-model="editWorkTypeInput"
                                placeholder="Enter work type name"></b-form-input>
                            </b-form-group>
                            <b-form-group :label="'Edit ' + lang.label.workPermit" label-for="edit_work_permit_template">
                              <b-form-input id="edit_work_permit_template" v-model="edit_work_permit_template"
                                placeholder="Edit work permit template"></b-form-input>
                            </b-form-group>
                            <base-input 
                                        :label="lang.label.requiredDocuments" 
                                        name="required_documents" 
                                       
                                        labelClasses="form-control-label asterisk-mark"
                                      >
                                        <el-select 
                                          v-model="editdocuments" 
                                          autocomplete="off"
                                          placeholder="Type and press Enter to add document" 
                                          filterable 
                                          multiple
                                          class="w-100"
                                          default-first-option
                                          value-key="name"
                                          @keyup.enter.native="handleEditEnterPress"
                                        >
                                        <el-option 
                                            v-for="doc in allDocuments" 
                                            :key="doc.id || doc.name"
                                            :label="doc.name || doc"
                                            :value="{ id: doc.id, name: doc.name }"
                                          >
                                            {{ doc.name || doc }}
                                          </el-option>
                                        </el-select>
                                      </base-input>
                            <!-- <base-input 
                              :label="lang.label.requiredDocuments" 
                              name="required_documents" 
                              rules="required"
                              labelClasses="form-control-label asterisk-mark"
                            >
                              <el-select 
                                v-model="editdocuments" 
                                autocomplete="off"
                                :placeholder="lang.label.selectDocuments" 
                                filterable 
                                multiple
                                class="w-100"
                              >
                                <el-option 
                                  v-for="doc in requiredDocument" 
                                  :key="doc.id"
                                  :label="doc.name"
                                  :value="doc.id"
                                >
                                  {{ doc.name }}
                                </el-option>
                              </el-select>
                            </base-input> -->
                          </div>
                        </b-modal>

                        <!-- Delete Work Type Modal -->
                        <b-modal id="deleteWorkTypeModal" title="Delete Work Type" @cancel="closeDeleteModal"
                          @ok="confirmDeleteWorkType">
                          <p>Are you sure you want to delete this work type?</p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit">{{
                    lang.label.buttons.save
                    }}</base-button>
                  <base-button type="danger" @click="$router.push({ name: 'siteManagementList' })">{{
                    lang.label.buttons.cancel
                    }}</base-button>
                </div>
              </form>
            </validation-observer>
            <el-dialog :visible.sync="modalVisible" title="Add Approver Details">
              <form @submit.prevent="saveApproverDetails">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input v-model="modalData.Name" type="text" class="form-control" placeholder="Enter name" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input v-model="modalData.EmailAddress" type="email" class="form-control" placeholder="Enter email"
                    required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Password</label>
                  <input v-model="modalData.Password" type="password" class="form-control" placeholder="Enter password"
                    required />
                </div>
                <div class="d-flex justify-content-end">
                  <button type="button" class="btn btn-secondary me-2" @click="modalVisible = false">Cancel</button>
                  <button type="submit" class="btn btn-primary">Save</button>
                </div>
              </form>
            </el-dialog>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Alert from "@/components/BaseAlert.vue";
import { Table, TableColumn, Select, Option, Button, Message, Dialog, Tag, Input } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { mapGetters } from "vuex";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Input.name]: Input,
    'el-dialog': Dialog,
    RouteBreadCrumb,
    Alert,
  },
  data() {
    return {
      communicationModes: [
        { text: "SMS", value: "1" },
        { text: "Email", value: "2" },
        { text: "Both", value: "3" },
        { text: "No communication", value: "4" },
      ],
      covidSafetyOptions: [
        { text: "Vaccinated", value: "1" },
        { text: "PCR Test", value: "2" },
        { text: "None", value: "3" },
      ],
      checked: [],
      approve: [
        { text: "Auto approve", value: "AutoApprove", disabled: false },
        { text: "Allow 15 hours", value: "Allow24Hrs", disabled: false },
      ],
      loading: true,
      alertType: "danger",
      successType: "success",
      alertMessage: {},
      lang: this.$lang.site_management,
      model: {
        siteName: "",
        companyName: "",
        mode: "",
        hours: "",
        frequencyWeek: "",
      },
      selects: {
        simple: "Select",
      },
      companyName: [],
      editWorkTypeInput: '',
      edit_work_permit_template: '',
      editdocuments: [],
      editIndex: null,
      departmentName: "",
      documentName: [],
      departments: [],
      approvers: [],
      approversName: [],
      approverLevels: [
        { key: "level_one_approvers", label: "Level 1 Approvers" },
        { key: "level_two_approvers", label: "Level 2 Approvers" },
        { key: "level_three_approvers", label: "Level 3 Approvers" },
      ],
      modalVisible: false,
      modalData: {
        departmentIndex: null,
        levelKey: "",
        approverIndex: null,
        Name: "",
        EmailAddress: "",
        Password: "",
      },
      requiredDocument: [],
      newWorkType: '',
      work_permit_template: '',
      workTypes: [],
    };
  },
  computed: {
    ...mapGetters({
      login: "login",
    }),
    isCompanyAdmin() {
      return this.login && this.login.IsCompanyAdmin === true;
    },
    userCompanyID() {
      return this.login && this.login.CompanyID ? this.login.CompanyID : null;
    },
    getApproversNameByCompany() {
      if (this.model.companyName == "") return [];
      return this.approvers.filter(approver => approver.CompanyName == this.model.companyName);
    },
    allDocuments() {
      const customDocs = this.editdocuments.filter(doc => 
        !this.requiredDocument.some(reqDoc => reqDoc.name === doc.name)
      );
      return [...this.requiredDocument, ...customDocs];
    }
  },
  mounted() {
    this.getAllApproversList();
    this.$store.dispatch("companyList").then((response) => {
      this.companyName = response.data;
      
      // Set default company if user is company admin
      if (this.isCompanyAdmin && this.userCompanyID) {
        const selectedCompany = this.companyName.find(c => c.ID === this.userCompanyID);
        if (selectedCompany) {
          this.model.companyName = selectedCompany.Name;
        }
      }
      
      this.loading = false;
    });
    this.getRequiredDocuments();
  },
  methods: {
    handleEnterPress(event) {
      const inputValue = event.target.value.trim().toLowerCase();
      
      const existingNames = [
        ...this.requiredDocument.map(doc => doc.name.toLowerCase()),
        ...this.documentName.map(doc => (doc.name || doc).toLowerCase())
      ];
      
      const isDuplicate = existingNames.includes(inputValue);
      
      if (inputValue && !isDuplicate) {
        this.documentName.push(inputValue);
      } else if (isDuplicate) {
        this.$message.warning('This document name already exists');
      }
      event.target.value = '';
    },
    handleEditEnterPress(event) {
      const inputValue = event.target.value.trim().toLowerCase();
    // Compare existing document names from both arrays
    const existingNames = [
      ...this.requiredDocument.map(doc => doc.name.toLowerCase()),
      ...this.editdocuments.map(doc => (doc.name || doc).toLowerCase())
    ];
    const isDuplicate = existingNames.includes(inputValue);
    if (inputValue && !isDuplicate) {
      this.editdocuments.push(inputValue);
    } else if (isDuplicate) {
      this.$message.warning('This document name already exists');
    }
    event.target.value = '';
    },
    validateLevelOneApprovers() {
      let invalidDepartments = this.departments.filter(department => {
        // Check if level_one_approvers.ids exists and has items, or if level_one_approvers array has items
        return (!department.level_one_approvers.ids || department.level_one_approvers.ids.length === 0) &&
          (!department.level_one_approvers.length || department.level_one_approvers.length === 0);
      });

      if (invalidDepartments.length > 0) {
        this.alertMessage = {
          type: 'danger',
          message: `Please select Level One approvers for departments: ${invalidDepartments.map(d => d.name).join(', ')}`
        };
        return false;
      }
      return true;
    },
    handleApproverSelection(depIndex, levelKey) {
      this.departments[depIndex][levelKey].ids.map(id => ({ ID: id })) || [];
    },
    validate(depIndex, levelKey) {
      const level = this.departments[depIndex][levelKey];
      if (!level) return false;
      const hasIds = Array.isArray(level.ids) && level.ids.length > 0;
      const hasEmails = level.some(id => id.EmailAddress);
      return hasIds || hasEmails;
    },
    editDepartment(index) {
      this.departments[index].editing = true;
    },
    saveDepartment(index) {
      this.departments[index].editing = false;
    },
    removeDepartment(index) {
      this.departments.splice(index, 1);
    },
    toggleDepartment(index) {
      this.departments[index].expanded = !this.departments[index].expanded;
    },
    addEmail(depIndex, levelKey) {
      this.departments[depIndex][levelKey].emails.push("");
    },
    removeEmail(depIndex, levelKey, emailDataIndex) {
      this.departments[depIndex][levelKey].splice(emailDataIndex, 1);
    },
    addApprover(depIndex, levelKey) {
      this.departments[depIndex][levelKey].push({ ID: null });
    },
    removeApprover(depIndex, levelKey, approverIndex) {
      this.departments[depIndex][levelKey].splice(approverIndex, 1);
    },
    openApproverModal(depIndex, levelKey, approverIndex) {
      this.modalData = { departmentIndex: depIndex, levelKey, approverIndex, Name: "", EmailAddress: "", Password: "" };
      this.modalVisible = true;
    },
    saveApproverDetails() {
      const { departmentIndex, levelKey, approverIndex, Name, EmailAddress, Password } = this.modalData;

      if (!this.departments[departmentIndex][levelKey]) {
        this.$set(this.departments[departmentIndex], levelKey, []);
      }

      this.departments[departmentIndex][levelKey].push({
        Name,
        EmailAddress,
        Password,
      });
      this.validate(departmentIndex, levelKey);

      this.modalData = {
        departmentIndex: null,
        levelKey: "",
        approverIndex: null,
        Name: "",
        EmailAddress: "",
        Password: "",
      };
      this.modalVisible = false;
    },
    getAllApproversList() {
      let self = this;
      self.$store.dispatch('listOfApprovers')
        .then(response => {
          self.approvers = response;
        })
        .catch(error => {
          console.error('Error fetching approvers:', error);
        });
    },
    showDeleteModal(index) {
      this.editIndex = index;
      this.$bvModal.show('deleteWorkTypeModal');
    },
    closeDeleteModal() {
      this.$bvModal.hide('deleteWorkTypeModal');
    },
    confirmDeleteWorkType() {
      this.workTypes.splice(this.editIndex, 1);
      this.alertMessage = {
        type: 'success',
        message: 'Work type deleted successfully!'
      };
      this.closeDeleteModal();
      setTimeout(function () {
        this.alertMessage = {};
      }, 2000);
    },
    addWorkType(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.newWorkType.trim() && this.work_permit_template.trim() && this.documentName.length > 0) {
        this.workTypes.push({
          id: Date.now(),
          name: this.newWorkType,
          documentName: this.documentName.map(doc => ({ name: doc.name || doc })),
          work_permit_template: this.work_permit_template,
          actions: "",
        });
        this.newWorkType = '';
        this.work_permit_template = '';
        this.documentName = [];
        this.alertMessage = {
          type: 'success',
          message: 'Work type added successfully!'
        };
      } else {
        this.alertMessage = {
          type: 'danger',
          message: 'Please enter a valid work type.'
        };
      }
      setTimeout(() => {
        this.alertMessage = {};
      }, 2000);
    },
    showEditModal(item, index) {
      this.editIndex = index;
      this.editWorkTypeInput = item.name;
      this.edit_work_permit_template = item.work_permit_template;
      this.editdocuments = [...item.documentName];
      this.$bvModal.show('editWorkTypeModal');
    },
    confirmEditWorkType() {
      if (this.editIndex !== null) {
        const updatedWorkType = {
          ...this.workTypes[this.editIndex],
          name: this.editWorkTypeInput,
          work_permit_template: this.edit_work_permit_template,
          documentName: [...this.editdocuments],
        };
        this.$set(this.workTypes, this.editIndex, updatedWorkType);
        this.alertMessage = {
          type: 'success',
          message: 'Work type updated successfully!'
        };
      }
      setTimeout(function () {
        this.alertMessage = {};
      }, 2000);
      this.closeEditModal();
    },
    closeEditModal() {
      this.editWorkTypeInput = '';
      this.edit_work_permit_template = '';
      this.editdocuments = [];
      this.editIndex = null;
      this.$bvModal.hide('editWorkTypeModal');
    },
    deleteWorkType(index) {
      this.$confirm(
        'Are you sure you want to delete this work type?',
        'Delete Confirmation',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.workTypes.splice(index, 1);
          this.alertMessage = {
            type: 'success',
            message: 'Work type deleted successfully!'
          };
        })
        .catch(() => {
          this.alertMessage = {
            type: 'danger',
            message: 'Delete canceled.'
          };
        });
      setTimeout(function () {
        this.alertMessage = {};
      }, 2000);
    },
    addDepartment(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.departmentName.trim()) {
        this.departments.push({
          name: this.departmentName,
          expanded: true,
          level_one_approvers: [],
          level_two_approvers: [],
          level_three_approvers: [],
        });
        this.departmentName = '';
        this.alertMessage = {
          type: 'success',
          message: 'Department added successfully!'
        };
      } else {
        this.alertMessage = {
          type: 'danger',
          message: 'Please enter a valid Department.'
        };
      }
      setTimeout(function () {
        this.alertMessage = {};
      }, 2000);
    },
    checkHours(index, evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (parseInt(this.model.hours) == 0) {
        this.model.hours = "";
        evt.preventDefault();
        return true;
      }
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    onSubmit() {
      if (!this.validateLevelOneApprovers()) {
        this.alertMessage = {
          type: 'danger',
          message: 'Please add a valid Department with approvers.'
        };
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      let self = this;
      this.loading = true;
      let selectedSite = this.companyName.filter((c) => {
        return c.Name == this.model.companyName;
      });
      if (selectedSite.length) {
        let data = {
          Name: this.model.siteName,
          CompanyID: selectedSite[0].ID,
          CovidSafety: this.model.covidSafety,
          FrequencyWeek: this.model.frequencyWeek,
        };
        data.work_types = this.workTypes.map(workType => ({
          name: workType.name,
          required_documents: workType.documentName.map(doc => ( {name: doc.name || doc} )),
          work_permit_template: workType.work_permit_template
        }));
        data.departments = this.departments.map(department => ({
          name: department.name,
          level_one_approvers: department.level_one_approvers.ids
            ? [...department.level_one_approvers.ids.map(id => ({ ID: id })), ...department.level_one_approvers]
            : [...department.level_one_approvers],
          level_two_approvers: department.level_two_approvers.ids
            ? [...department.level_two_approvers.ids.map(id => ({ ID: id })), ...department.level_two_approvers]
            : [...department.level_two_approvers],
          level_three_approvers: department.level_three_approvers.ids
            ? [...department.level_three_approvers.ids.map(id => ({ ID: id })), ...department.level_three_approvers]
            : [...department.level_three_approvers],
        }))

        data.AutoApprove = this.checked.includes("AutoApprove");
        data.Allow24Hrs = this.checked.includes("Allow24Hrs");
        data.StartDateBeforeX = this.model.hours ? this.model.hours : null;
        data.SiteCommsPref = this.model.mode;
        this.$store.dispatch("addSite", data).then((response) => {
          if (response.status == 200) {
            this.flash({ message: response.data.message, variant: "success" });
            this.$router.push({ name: "siteManagementList" });
          } else {
            if (typeof response.data.message != "object") {
              this.alertMessage = {
                type: 'danger',
                message: response.data.message
              };
            } else {
              let array = new Array();
              for (let key of Object.keys(response.data.message)) {
                let obj = response.data.message[key][0].includes("field")
                  ? key + "- " + response.data.message[key][0]
                  : response.data.message[key];
                array.push(obj);
              }
              this.alertMessage = {
                type: 'danger',
                message: array.join(", ")
              };
              setTimeout(function () {
                self.alertMessage = {};
              }, 2000);
            }
            self.loading = false;
          }
        });
      }
    },
    async getRequiredDocuments() {
      try {
        const response = await this.$store.dispatch("fetchDocuments");
        if (response.data) {
          this.requiredDocument = response.data;
        }
      } catch (error) {
        console.error('Error fetching documents:', error);
      }
    },
    handleDocumentSelection(selectedDocs) {
      // selectedDocs will be array of full document objects
      this.documentName = selectedDocs;
    }
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

.modal-header {
  padding-bottom: 0;
}

.modal-backdrop {
  z-index: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
